import { Box, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useCallback } from "react";
import { useCommonMainButtonsStyles } from "../../../themes/style-hooks";

type MainActionsProps = {
  classNames?: string;
};

const useMainActionsLayout = makeStyles({
  root: {
    width: "100%",
    height: 64,
    display: "grid",
    gridTemplateColumns: "auto auto",
    justifyContent: "center",
    justifyItems: "center",
    gridColumnGap: 182,
    ["@media screen and (max-width: 1200px), screen and (max-height: 900px)"]: {
      gridColumnGap: 140,
    },
    ["@media screen and (max-width: 850px), screen and (max-height: 650px)"]: {
      height: "auto",
      gridColumnGap: 60,
    },
    ["@media screen and (max-width: 570px) and (orientation: portrait)"]: {
      flexDirection: "column",
      gridTemplateColumns: "none",
      gridRowGap: 12,
    },
  },
});

export const MainActions: React.FC<MainActionsProps> = ({ classNames }) => {
  const mainActionsLayout = useMainActionsLayout();
  const commonMainButtonsStyles = useCommonMainButtonsStyles({});
  // const isMobileView = useIsMobileView();
  // const [open, setOpen] = useState(false);

  const onSignInHandler = useCallback(() => {
    // if (!isMobileView) {
    // eslint-disable-next-line no-undef
    window.history.pushState(undefined, "/");
    // eslint-disable-next-line no-undef
    window.location.replace("/sign-in");
    // return;
    // }
    // setOpen(true);
  }, []);

  const onSignUpHandler = useCallback(() => {
    // if (!isMobileView) {
    // eslint-disable-next-line no-undef
    window.history.pushState(undefined, "/");
    // eslint-disable-next-line no-undef
    window.location.replace("/sign-up");
    // return;
    // }
    // setOpen(true);
  }, []);

  return (
    <Box
      className={`${mainActionsLayout.root} ${commonMainButtonsStyles.common}`}
    >
      {/* <Button
        variant="contained"
        disableRipple
        className={classNames}
        onClick={() => {
          navigate("/browse/subscribe/?type=professionals");
        }}
      >
        Browse Professionals
      </Button>
      <Button
        variant="contained"
        disableRipple
        className={classNames}
        onClick={() => {
          navigate("/jobs/subscribe");
        }}
      >
        View Listed Projects
      </Button> */}
      <Button
        variant="contained"
        disableRipple
        className={classNames}
        onClick={onSignInHandler}
      >
        Sign In
      </Button>
      <Button
        variant="contained"
        disableRipple
        className={classNames}
        onClick={onSignUpHandler}
      >
        Sign Up
      </Button>
      {/*<MobileNotSupportedDialog open={open} onClose={() => setOpen(false)} />*/}
    </Box>
  );
};
